<oo-loading-container [status]="state.status">
  <ng-template>
    <oo-list-header title="Forms"></oo-list-header>

    <mat-card appearance="outlined">
      <mat-card-content>
        @if (state.forms.length) {
          <mat-nav-list>
            @for (form of state.forms; track form) {
              <div class="oo-form-wrapper">
                <a (click)="onFormItemClick(form)"
                   [routerLink]="form.hasBettingResult ? ['../formResults', form.id] : ['../formBetting', form.id]"
                   mat-list-item>
                  <mat-icon matListItemIcon>{{ getFormIcon(form) }}</mat-icon>
                  <div matListItemTitle>{{ form.name }}</div>
                  @if (getCurrentDate() <= form.startsAt) {
                    <div
                      matListItemLine>{{ form.startsAt | date:'dd/MM/yyyy HH:mm' }}
                    </div>
                  }
                  @if (getCurrentDate() > form.startsAt) {
                    <div matListItemLine>Betting closed</div>
                  }
                </a>
                @if (state.competitionGroup.role === 'admin') {
                  <div class="oo-more-wrapper">
                    <button [matMenuTriggerFor]="menu" mat-icon-button>
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      @if (state.competitionGroup.role === 'admin') {
                        <a (click)="openStatusDialog(form)"
                           mat-menu-item>
                          <mat-icon>check_circle</mat-icon>
                          <span>Submission Status</span>
                        </a>
                      }
                    </mat-menu>
                  </div>
                }
              </div>
            }
          </mat-nav-list>
        }
        @if (!state.forms.length) {
          <div>
            No forms yet{{ state.competitionGroup.role === 'admin' ? ', please create one' : '' }}
          </div>
        }
      </mat-card-content>
    </mat-card>
  </ng-template>
</oo-loading-container>
